
import React from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import MainNav from "@/components/MainNav";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardList, Users, Trophy, Activity, BookOpen } from "lucide-react";

interface AdminLayoutProps {
  children?: React.ReactNode;
  title?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, title }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  return (
    <>
      <MainNav currentPath="admin" />
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">{title || "Admin Dashboard"}</h1>
          <p className="text-muted-foreground mt-1">
            Manage your application settings and monitor activity
          </p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-6">
          {/* Sidebar Navigation */}
          <div className="w-full md:w-64 space-y-2">
            <div className="space-y-1">
              <h3 className="font-medium text-sm px-2 py-1">Administration</h3>
              <Link to="/admin/users">
                <Button 
                  variant={currentPath === "/admin/users" ? "default" : "ghost"} 
                  className="w-full justify-start"
                >
                  <Users className="mr-2 h-4 w-4" />
                  Users
                </Button>
              </Link>
              <Link to="/admin/permanent-plans">
                <Button 
                  variant={currentPath === "/admin/permanent-plans" ? "default" : "ghost"} 
                  className="w-full justify-start"
                >
                  <Trophy className="mr-2 h-4 w-4" />
                  Permanent Pro
                </Button>
              </Link>
              <Link to="/admin/widget-status">
                <Button 
                  variant={currentPath === "/admin/widget-status" ? "default" : "ghost"} 
                  className="w-full justify-start"
                >
                  <Activity className="mr-2 h-4 w-4" />
                  Widget Status
                </Button>
              </Link>
              <Link to="/admin/logs">
                <Button 
                  variant={currentPath === "/admin/logs" ? "default" : "ghost"} 
                  className="w-full justify-start"
                >
                  <ClipboardList className="mr-2 h-4 w-4" />
                  Logs
                </Button>
              </Link>
              <Link to="/admin/documentation">
                <Button 
                  variant={currentPath === "/admin/documentation" ? "default" : "ghost"} 
                  className="w-full justify-start"
                >
                  <BookOpen className="mr-2 h-4 w-4" />
                  Documentation
                </Button>
              </Link>
            </div>
          </div>
          
          {/* Main Content */}
          <div className="flex-1">
            {children || <Outlet />}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
